import { SubtaskDto } from '@sib/api';
import { TaskItemCard } from '@sidecar/common/components/TaskItemCard';

interface SubtaskCardProps {
  subtask: SubtaskDto;
  canEdit: boolean;
  disabled: boolean;
  disabledTooltip: string;
  editLabel: string;
  onEdit: () => void;
  onToggle: () => void;
}

export const SubtaskCard = ({
  subtask: {
    completed,
    title,
    description,
    priorityLevel,
    assigneeUser,
    deadline,
    uuid,
  },
  canEdit,
  disabled,
  disabledTooltip,
  editLabel,
  onEdit,
  onToggle,
}: SubtaskCardProps) => (
  <TaskItemCard
    isComplete={completed}
    title={title}
    description={description}
    priorityLevel={priorityLevel}
    assignee={assigneeUser}
    dueDate={deadline}
    canEdit={canEdit}
    disabled={disabled}
    disabledTooltip={disabledTooltip}
    checkboxId={`subtask-checkbox-${uuid}`}
    editLabel={editLabel}
    onEdit={onEdit}
    onToggle={onToggle}
  />
);
